module.exports = __webpack_public_path__ + "img/ic_referral_detail.15b31709.svg";